/**
 * 可图 1.5（kling-v1-5）manifest
 * 数据来源：image.json field_map（旧模型，接口 disable: true）
 * 特点：无清晰度/质量分档；比例不带真实像素；参考图上限 1；支持参考模式（角色特征/人物长相）
 */
import type { ImageModelConfig } from '../../types';

export const kling1_5: ImageModelConfig = {
  id: '01JVKEM9JE2057KPET1K7AVQFY',
  displayName: '可图 1.5',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    refType: 1, // 接口 ref_type.default（注：field_map 里 select 标在 value=2，数据本身不一致，忠实转写 default）
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  refTypeOptions: [
    { label: '角色特征', value: 1, source: ['human_fidelity', 'image_fidelity'] },
    { label: '人物长相', value: 2, source: ['human_fidelity'], select: true },
  ],

  toggles: {},

  limits: {
    maxRefImages: 1, // 接口 field_map.ref_images.max
  },
};
